import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';

export const PriceList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  > li:not(:last-child) {
    margin-bottom: ${layout.measurements.spacing050};
  }
`;

export const PricePanel = styled.div`
  margin-bottom: 20px;

  ${media.mediumUp`
    margin-bottom: 30px;
  `}

  > ul:not(:last-child) {
    margin-bottom: ${layout.measurements.spacing100};
  }
`;

export const HeaderWrapper = styled.div`
  margin-top: ${layout.measurements.spacing150};
  margin-bottom: ${layout.measurements.spacing100};
`;

export const ScrollingFiltersList = styled.div`
  width: 100%;
  overflow-x: auto;

  ${media.smallOnly`
    width: 100vw;
    overflow-x: auto;
    margin-left: -16px;
    padding: 0 8px;
  `}
`;

export const ScrollingFiltersListWrapper = styled.div`
  display: flex;
  padding: 6px 0;

  ${media.mediumUp`
    flex-wrap: wrap;

    > button {
      margin-bottom: ${layout.measurements.spacing050};
    }
  `}

  > button {
    flex-shrink: 0;

    &:not(:last-child) {
      margin-right: ${layout.measurements.spacing050};
    }
  }
`;

export const HideOnMobile = styled.div`
  ${media.smallOnly`
    display: none;
  `}
`;

export const ShowOnMobile = styled.div`
  ${media.mediumUp`
    display: none;
  `}
`;

export const SortingBy = styled.div<{ $mobile: boolean }>`
  ${p =>
    !p.$mobile
      ? media.smallOnly`
      display: none;
    `
      : media.mediumUp`
      display: none;
    `}
`;
